import * as api from 'config/axios';
import * as endpoints from './endpoints';

//Fetch comments from API (GET)
export const fetchComments = async () => {
  try {
    const response = await api.sendGet(endpoints.GET_COMMENTS);
    return response.data || []; // Return empty array if no data
  } catch (error) {
    console.error('Error fetching comments:', error);
    return [];
  }
};

// Fetch QA Workflow Comments
export const fetchQaWorkflowComments = async () => {
  try {
    const response = await api.sendGet(endpoints.GET_QA_WORKFLOW_COMMENTS);
    return response.data || [];
  } catch (error) {
    console.error('Error fetching QA Workflow comments:', error);
    return [];
  }
};

// Update Comment Status (POST)
export const updateCommentStatus = async ({
  id,
  productId,
  ownerId,
  supplierId,
  supplierSubmittedDate,
  commentStatus,
  lastUpdatedBy,
}) => {
  try {
    const response = await api.sendPost(endpoints.UPDATE_COMMENT_STATUS, {
      id,
      productId,
      ownerId,
      supplierId,
      supplierSubmittedDate,
      commentStatus,
      lastUpdatedBy,
    });

    return response.data;
  } catch (error) {
    console.error('Error updating comment status:', error);
    throw error;
  }
};

export const saveTraceableComment = (params) => {
  return api.sendPost(endpoints.SAVE_COMMENTS, params);
};

export const getTraceableComment = (params) => {
  return api.sendGet(endpoints.GET_COMMENTS, { params });
};

export const getTraceableCommentCount = (params) => {
  const count = api.sendGet(endpoints.GET_COMMENT_COUNT, { params });
  return count;
};

export const updateTraceableCommentCount = (params) => {
  return api.sendPut(endpoints.PUT_COMMENT_COUNT, params);
};

export const fetchTraceableCommentsByFieldName = async ({
  productId,
  qaSpecName,
  qaSpecFieldName,
  isSupplier = false,
  fromDate,
  toDate,
}) => {
  try {
    if (!productId || !qaSpecName || !qaSpecFieldName) {
      throw new Error('Missing required query parameters.');
    }

    const queryParams = new URLSearchParams({
      ProductId: productId,
      QASpecName: qaSpecName,
      QASpecFieldName: qaSpecFieldName,
      IsSupplierComment: isSupplier.toString(),
    });

    if (fromDate) queryParams.append('FromDate', fromDate);
    if (toDate) queryParams.append('ToDate', toDate);

    const url = `${endpoints.GET_COMMENTS}?${queryParams.toString()}`;
    return await api.sendGet(url);
  } catch (error) {
    console.error('Error fetching traceable comments:', error);
    return [];
  }
};
